'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _homepageHero = require('../../homepage-hero');

var _homepageHero2 = _interopRequireDefault(_homepageHero);

var _actionDropdown = require('../../../molecules/action-dropdown');

var _actionDropdown2 = _interopRequireDefault(_actionDropdown);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'action-hero';

var renderActionDropdown = function renderActionDropdown(actionDropdown) {
  if (actionDropdown) {
    return _react2.default.createElement(_actionDropdown2.default, actionDropdown);
  }
  return null;
};

var ActionHero = function (_HomePageHero) {
  _inherits(ActionHero, _HomePageHero);

  function ActionHero() {
    _classCallCheck(this, ActionHero);

    return _possibleConstructorReturn(this, (ActionHero.__proto__ || Object.getPrototypeOf(ActionHero)).apply(this, arguments));
  }

  _createClass(ActionHero, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var theme = this.props.config.theme || 'theme-background-image-dark';
      var newProps = (0, _themeManager2.default)({ content: this.props.content }, theme);
      var content = newProps.content;
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          viewport = _props.viewport;
      var headline = content.headline,
          paragraph = content.paragraph,
          mediaButton = content.mediaButton,
          primaryCta = content.primaryCta,
          secondaryCta = content.secondaryCta,
          hatchText = content.hatchText,
          actionDropdown = content.actionDropdown;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME + '-organism', className);
      var heroClasses = (0, _classnames2.default)(ORGANISM_NAME, 'home-hero', config.height || 'tall', theme);

      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);
      var backgroundPosition = config.backgroundImage && config.backgroundPosition;
      var backgroundImageStyle = backgroundImage ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      return _react2.default.createElement(
        'section',
        {
          ref: function ref(c) {
            _this2.organismRef = c;
          },
          id: config.id ? config.id : null,
          className: sectionClasses,
          'data-building-block': 'organism'
        },
        _react2.default.createElement(
          'div',
          { className: heroClasses, style: backgroundImageStyle },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: this.getAlignment(config.textAlign) },
                this.state.isMobile && paragraph && paragraph.text ? _react2.default.createElement(
                  'div',
                  null,
                  this.renderHeadline(headline)
                ) : _react2.default.createElement(
                  'div',
                  null,
                  this.renderHeadline(headline),
                  this.renderParagraph(paragraph),
                  this.renderMediaButton(mediaButton),
                  this.renderCta(primaryCta),
                  this.renderCta(secondaryCta),
                  renderActionDropdown(actionDropdown),
                  this.renderHatchText(hatchText)
                )
              )
            )
          )
        ),
        this.state.isMobile && paragraph && paragraph.text && _react2.default.createElement(
          'div',
          { className: 'below-' + ORGANISM_NAME + ' below-home-hero' },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: this.getAlignment(config.textAlign) },
                this.renderParagraph(paragraph),
                this.renderMediaButton(mediaButton, 'outline-blue'),
                this.renderCta(primaryCta),
                this.renderCta(secondaryCta, 'outline-blue'),
                renderActionDropdown(actionDropdown),
                this.renderHatchText(hatchText)
              )
            )
          )
        )
      );
    }
  }]);

  return ActionHero;
}(_homepageHero2.default);

exports.default = ActionHero;


ActionHero.propTypes = {
  viewport: _propTypes2.default.string,
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }).isRequired,
    theme: _propTypes2.default.oneOf(['theme-background-image-dark', 'theme-background-image-light']),
    height: _propTypes2.default.oneOf(['short', 'tall']),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right']),
    textAlign: _propTypes2.default.oneOf(['center', 'left']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    mediaButton: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      id: _propTypes2.default.string
    }),
    primaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    secondaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    actionDropdown: _actionDropdown2.default.propTypes,
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

ActionHero.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/action-hero/jsx/ActionHero.js
// module id = 1068
// module chunks = 4